import request from '@/utils/request'
import {SettingMer} from '@/utils/settingMer';

/**
 * 通过手机号查询审核进度
 */
export function joinApplyHistory(data) {
    return request({
        url: SettingMer.apiOrgURL + 'org/mcn/apply/joinApply/history',
        method: 'post',
        data
    })
}

/**
 * 通过applyId查询申请进度
 */
export function joinApplyProgress(data) {
    return request({
        url: SettingMer.apiOrgURL + 'org/mcn/apply/joinApply/progress',
        method: 'post',
        data
    })
}

/**
 * 申请入驻-名称检查
 */
export function joinApplyNameCheck(params) {
    return request({
        url: SettingMer.apiOrgURL + 'org/mcn/apply/joinApply/name/check',
        method: 'get',
        params
    })
}

/**
 * 获取短信验证码
 */
export function getSMSVerifyCode(data) {
    return request({
        url: SettingMer.apiOrgURL + 'org/mcn/apply/sms/get',
        method: 'post',
        data
    })
}

/**
 * 获取图形验证码
 */
export function getImgVerifyCode(data) {
    return request({
        url: SettingMer.apiOrgURL + 'org/mcn/apply/graphCode/get',
        method: 'post',
        data
    })
}

/**
 * 申请入驻-保存第一步信息
 */
export function stepOneSave(data) {
    return request({
        url: SettingMer.apiOrgURL + 'org/mcn/apply/joinApply/stepOne/save',
        method: 'post',
        data
    })
}

/**
 * 申请入驻-保存第二步信息
 */
export function stepTwoSave(data) {
    return request({
        url: SettingMer.apiOrgURL + 'org/mcn/apply/joinApply/stepTwo/save',
        method: 'post',
        data
    })
}

/**
 * 提交信息
 */
export function submitSaveAll(data) {
    return request({
        url: SettingMer.apiOrgURL + 'org/mcn/apply/joinApply/submit',
        method: 'post',
        data
    })
}

/**
 * 申请入驻-OCR-身份证
 */
export function ocrIdCard(imgUrl) {
    if (!imgUrl) {
        return
    }
    return request({
        url: SettingMer.apiOrgURL + 'org/mcn/apply/ocr/idCard',
        method: 'post',
        data: {
            url: imgUrl
        }
    })
}